import { h, Component } from "preact";
import Api, { FullWork } from "../../api";
import Navigation, { Pages } from "../../navigation";
export interface AddProps { }
enum States {
   Form,
   Spinner
}
interface AddState {
   state: States;
   message: string;
}
export class AddComponent extends Component<AddProps, AddState> {
   input: HTMLInputElement;
   constructor(props: AddProps) {
      super(props);
      this.state = { state: States.Form, message: "" };
   }

   async addFromFile(file: File) {
      if (file.name.endsWith(".epub")) {
         console.log("Epub found!");
         try {
            await Api.addEPub(file);
         } catch (e) {
            alert("Some error occured, please try again later: " + e.message)
         }
      } else {
         await new Promise((yes, no) => {
            let r = new FileReader();
            r.onload = async (e) => {
               try {
                  this.setState({ state: States.Spinner });
                  let content: string = (e.target as any).result;
                  let wks = content.split("\n").map(e => e.trim()).filter(e => e !== "");
                  let current = 0;
                  let drawpg = () => {
                     this.setState({ message: `Converted ${current} from ${wks.length}` });
                  }
                  drawpg();
                  for (let w of wks) {
                     await Api.addWorkFromUrl(w)
                     current++;
                     drawpg();
                  }
               } catch (e) {
                  alert("Some error occured, please try again later: " + e.message)
               } finally {
                  yes();
               }
            }
            r.readAsText(file);
         });
      }
   }

   async componentWillMount() { }
   //style="background-color: {{theme.background}}; color: {{theme.color}}; font-size: {{font_size}}"
   render(props: AddProps, state: AddState) {
      let content;
      switch (state.state) {
         case States.Spinner:
            content = (
               <div id="add_work_loader" style="display:{{#if loader_visibility}}block{{else}}none{{/if}};">
                  <h3>{state.message}</h3>
                  <div style="width: 65px; height: 65px; margin: 0 auto;">
                     <svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="circle" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                     </svg>
                  </div>
               </div>)
            break;
         case States.Form:
         default:
            content = (<div>
               <div class="input-group">
                  <label for="url">Enter URL of work</label>
                  <input type="text" id="url" name="url" autofocus ref={elm => this.input = elm} />
                  <div class="error invisible" id="url_error"></div>
               </div>
               <div class="group">
                  <input class="btn" id="add_wp_book_bulk" type="file" multiple onChange={async evt => {
                     let files: File[] = (evt.target as any).files;
                     this.setState({ state: States.Spinner });
                     try {
                        for (let file of files) {
                           this.setState({ message: "Uploading " + file.name });
                           await this.addFromFile(file);
                        }
                        Navigation.setPage(Pages.Library, undefined);
                     } catch (e) {
                        alert("Failed to load file");
                     }
                     this.setState({ message: "" });
                     this.setState({ state: States.Form });
                     (evt.target as HTMLInputElement).value = null;
                  }} />
               </div>
               <button id="add_work_save" type="submit" class="btn" onClick={async evt => {
                  this.setState({ message: "Working", state: States.Spinner });
                  if (this.input) {
                     let url = this.input.value;
                     if (url)
                        await Api.addWorkFromUrl(url).then(() => {
                           this.input && (this.input.value = null)
                           Navigation.setPage(Pages.Library, undefined);
                        }).catch(err => alert(err.message))
                     this.setState({ message: "", state: States.Form });
                  }
               }}>Add</button>
            </div>);
      }

      return <div >
         <div style="background: var(--background); margin-top: -1px; padding-top:1px; height: 100%;">
            <div style="width: 100%;">
               <h2>Add work to library</h2>
               {content}
            </div>
         </div>
      </div>
   }
}